<header class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option"></div>
  <div class="top-header" *ngIf="topbar">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="header-contact">
            <ul>
              <li>Bem vindo a Confiança Turismo</li>
              <li><i class="fa fa-phone text-white" aria-hidden="true"></i>Telefone: (65) 3314-2700</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 text-end">
          <ul class="header-dropdown">
            <li class="compare" hidden>
              <a [routerLink]="['/shop/compare']"><i class="fa fa-random" aria-hidden="true"></i>Compare</a>
            </li>
            <li class="mobile-wishlist" hidden>
              <a [routerLink]="['/shop/wishlist']"><i class="fa fa-heart" aria-hidden="true"></i>Wishlist</a>
            </li>
            <li class="onhover-dropdown mobile-account">
              <i class="fa fa-user" aria-hidden="true"></i>
              <a *ngIf="emailUser == null">Fazer Login</a>
              <a *ngIf="emailUser != null">{{emailUser.email}}</a>
              <ul class="onhover-show-div">
                <li *ngIf="emailUser == null">
                  <a routerLink="/pages/login">
                    Login
                  </a>
                </li>
                <li *ngIf="emailUser != null">
                  <a routerLink="/pages/dashboard">
                    Dashboard
                  </a>
                </li>
                <li *ngIf="emailUser != null">
                  <a routerLink="/pages/profile">
                    Perfil
                  </a>
                </li>
                <li *ngIf="emailUser != null">
                  <a (click)="logoutS()">
                    Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="main-menu">
          <div class="menu-left">
            <!-- <app-left-menu></app-left-menu> -->
            <div class="brand-logo">
              <a routerLink="/shop/collection/no/sidebar" id="headerlogo">
                <img [src]="themeLogo" alt="logo" height="60"
                width="auto">
              </a>
            </div>
          </div>
          <div class="menu-right pull-right">
            <div>
              <app-menu></app-menu>
            </div>
            <div>
              <app-settings></app-settings>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
